import request from '@/service/index'
import postJson from "@/service/postJson"
/**
 * 新增修改商品
 */
export const saveProduct = (params) => {
    return request({
        url: 'item/shopItem/saveProdAndItem',
        params,
        method: 'post'
    })
}

/**
 * 获取商品详情
 */
export const getProductDetail = (itemId) => {
    return request({
        url: `item/shopItem/${itemId}/info`,
        method: 'get'
    })
}

//过期预警详情
export const qryArmShopItemListByShop = (params) => {
    return request({
        url: 'item/shopItem/qryArmShopItemListByShop',
        params,
        method: 'get'
    })
}

//过期详情
export const qryExpireShopItemListByShop = (params) => {
    return request({
        url: 'item/shopItem/qryExpireShopItemListByShop',
        params,
        method: 'get'
    })
}

//查询缺货柜子详情
export const qryLackShop = (params) => {
    return request({
        url: 'item/shopItem/qryLackShop',
        params,
        method: 'get'
    })
}

//确认补货
export const getReplenishDetail = (params) => {
    return request({
        url: 'item/stockLog/qryStockLogDetail',
        params,
        method: 'get'
    })
}

//确认补货
// export const confirmReplenish = (params) => {
//     return request({
//         //item/shopItemSkuStock/confirmReplenish
//         url: 'item/shopItemSkuStock/confirmReplenishV2',
//         params,
//         method: 'get'
//     })
// }
export const confirmReplenish = (data) => {
    return postJson({
        url: 'item/shopItemSkuStock/confirmReplenishV2',
        method: 'post',
        data,
        headers:{'Content-Type': 'application/json' }
    })
}

//商品上架、下架
export const updateProductState = (params) => {
    return request({
        url: 'item/shopItem/updateState',
        params,
        method: 'get'
    })
}
//移除商品
export const removeProduct = (data) => {
    return request({
        url: 'item/shopItem/remove',
        data,
        method: 'post'
    })
}
//移除商品
export const qryStockLogPickUpCount = (params) => {
    return request({
        url: 'item/stockLog/qryStockLogPickUpCount',
        params,
        method: 'get'
    })
}

//通过扫码69码获取对应产品Sku

export const getProdProductSkuByCode = (params) => {
    return request({
        url: 'item/productSku/getProdProductSkuByCode',
        params,
        method: 'get'
    })
}

export const getByShopIdAndBarCode = (params) => {
    return request({
        url: 'item/shopItemSku/getByShopIdAndBarCode',
        params,
        method: 'get'
    })
}

export const queryProdProductSkuList = (params) => {
    return request({
        url: 'item/productSku/list',
        params,
        method: 'get'
    })
}

export const getByProductId = (params) => {
    return request({
        url: 'item/prodProduct/getByProductId',
        params,
        method: 'get'
    })
}




// WEBPACK FOOTER //
// ./src/api/product.js